// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__bhMRd","buttons":"PendingPaymentAlert_buttons__3psfg"};